webpackJsonp([5],{

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var checkIfUrlCorrect = function checkIfUrlCorrect(url) {
	var startingString = "https://www.youtube.com/watch?v=";
	if (url.substring(0, startingString.length) == startingString) {
		return startingString;
	} else {
		console.log(url.substring(0, startingString.length));
	}

	var embedstarting = "https://youtu.be/";
	if (url.substring(0, embedstarting.length) == embedstarting) {
		return embedstarting;
	} else {
		console.log(url.substring(0, embedstarting.length));
	}

	return false;
};

var getVideoID = function getVideoID(url) {
	if (checkIfUrlCorrect(url)) {
		var baseID = url.replace(checkIfUrlCorrect(url), "");
		var baseIDArray = baseID.split(/(&|\?)/);
		var result = baseIDArray[0];
		return url.replace(checkIfUrlCorrect(url), "");
	}
	return false;
};

var getDataFromUrl = function getDataFromUrl() {
	try {
		var urlObj = new URL(window.location.href);
		var urlData = urlObj.searchParams.get("url") || urlObj.searchParams.get("text") || "";
		return urlData;
	} catch (e) {
		return "";
	}
};

var removeParamsFromUrl = function removeParamsFromUrl() {
	var newUrl = new URL(window.location.href);
	if (newUrl.search) {
		newUrl.search = "";
		return newUrl;
	}
	return false;
};

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'listLayout',
	data: function data() {
		return {
			newUrl: ""
		};
	},

	computed: {
		newUrlCorrect: function newUrlCorrect() {
			if (checkIfUrlCorrect(this.newUrl)) {
				return this.newUrl;
			}
		},
		youtubeVideoID: function youtubeVideoID() {
			return getVideoID(this.newUrl);
		}
	},
	components: {
		videoplayer: function videoplayer() {
			return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 108));
		}
	},
	methods: {
		addToCommunity: function addToCommunity() {
			this.$root.addVideo(this.newUrl);
			this.newUrl = "";
			var newUrlToGoTo = removeParamsFromUrl();
			if (!newUrlToGoTo) {
				this.$router.push('/ruttirecenti');
			} else {
				newUrlToGoTo.search = "";
				newUrlToGoTo.hash = "#/ruttirecenti";
				window.location.href = newUrlToGoTo.href;
			}
		}
	},
	beforeDestroy: function beforeDestroy() {
		if (this.$root && this.$root.closeMenu) {
			this.$root.closeMenu();
		}
	},
	mounted: function mounted() {
		var urlFromRoute = getDataFromUrl();
		this.newUrl = urlFromRoute;
	}
});

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, ".addRutto{text-align:left}.addRutto .inputBase{max-width:450px;margin:auto;margin-bottom:16px;background-color:#fff;-webkit-box-shadow:0 3px 15px rgba(0,0,0,.31);box-shadow:0 3px 15px rgba(0,0,0,.31);padding:25px}.addRutto .inputBase .inserisciUrl-cont{position:relative}.addRutto .inputBase .inserisciUrl-cont .gdr-icon{position:absolute;line-height:32px;width:32px;text-align:center;top:0;left:0;color:#cc181e!important}.addRutto .inputBase .inserisciUrl{display:block;line-height:32px;height:32px;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding-left:32px;padding-right:10px}.addRutto .addVideoAnteprimaVideo{background-color:#fff;-webkit-box-shadow:0 3px 15px rgba(0,0,0,.31);box-shadow:0 3px 15px rgba(0,0,0,.31);padding:25px;margin-bottom:150px;margin-left:auto;margin-right:auto}.addRutto .addVideoAnteprimaVideo p{padding-top:0;margin-top:0}.addRutto .addVideoAnteprimaVideo .buttonAddTo-cont{text-align:right}.addRutto .addVideoAnteprimaVideo .buttonAddTo-cont .buttonAddTo{background-color:#cc181e;color:#fff;border:none!important;line-height:32px;padding-left:10px;padding-right:10px;cursor:pointer;-webkit-box-shadow:0 3px 15px rgba(0,0,0,.6);box-shadow:0 3px 15px rgba(0,0,0,.6)}.addRutto .addVideoAnteprimaVideo .buttonAddTo-cont .buttonAddTo:hover{-webkit-transform:scale(1.05);transform:scale(1.05)}", "", {"version":3,"sources":["/home/matteo/development/garadirutti/pwa-gdr/src/components/addRutto.vue"],"names":[],"mappings":"AACA,UACE,eAAiB,CAClB,AACD,qBACE,gBAAiB,AACjB,YAAa,AACb,mBAAoB,AACpB,sBAAwB,AACxB,8CAAmD,AAC3C,sCAA2C,AACnD,YAAc,CACf,AACD,wCACE,iBAAmB,CACpB,AACD,kDACE,kBAAmB,AACnB,iBAAkB,AAClB,WAAY,AACZ,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,uBAA0B,CAC3B,AACD,mCACE,cAAe,AACf,iBAAkB,AAClB,YAAa,AACb,WAAY,AACZ,8BAA+B,AACvB,sBAAuB,AAC/B,kBAAmB,AACnB,kBAAoB,CACrB,AACD,kCACE,sBAAwB,AACxB,8CAAmD,AAC3C,sCAA2C,AACnD,aAAc,AACd,oBAAqB,AACrB,iBAAkB,AAClB,iBAAmB,CACpB,AACD,oCACE,cAAe,AACf,YAAc,CACf,AACD,oDACE,gBAAkB,CACnB,AACD,iEACE,yBAA0B,AAC1B,WAAa,AACb,sBAAwB,AACxB,iBAAkB,AAClB,kBAAmB,AACnB,mBAAoB,AACpB,eAAgB,AAChB,6CAAkD,AAC1C,oCAA0C,CACnD,AACD,uEACE,8BAA+B,AACvB,qBAAuB,CAChC","file":"addRutto.vue","sourcesContent":["\n.addRutto {\n  text-align: left;\n}\n.addRutto .inputBase {\n  max-width: 450px;\n  margin: auto;\n  margin-bottom: 16px;\n  background-color: white;\n  -webkit-box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);\n          box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);\n  padding: 25px;\n}\n.addRutto .inputBase .inserisciUrl-cont {\n  position: relative;\n}\n.addRutto .inputBase .inserisciUrl-cont .gdr-icon {\n  position: absolute;\n  line-height: 32px;\n  width: 32px;\n  text-align: center;\n  top: 0;\n  left: 0;\n  color: #cc181e !important;\n}\n.addRutto .inputBase .inserisciUrl {\n  display: block;\n  line-height: 32px;\n  height: 32px;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding-left: 32px;\n  padding-right: 10px;\n}\n.addRutto .addVideoAnteprimaVideo {\n  background-color: white;\n  -webkit-box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);\n          box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);\n  padding: 25px;\n  margin-bottom: 150px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.addRutto .addVideoAnteprimaVideo p {\n  padding-top: 0;\n  margin-top: 0;\n}\n.addRutto .addVideoAnteprimaVideo .buttonAddTo-cont {\n  text-align: right;\n}\n.addRutto .addVideoAnteprimaVideo .buttonAddTo-cont .buttonAddTo {\n  background-color: #cc181e;\n  color: white;\n  border: none !important;\n  line-height: 32px;\n  padding-left: 10px;\n  padding-right: 10px;\n  cursor: pointer;\n  -webkit-box-shadow: 0 3px 15px rgba(0, 0, 0, 0.6);\n          box-shadow: 0 3px 15px rgba(0, 0, 0, 0.6);\n}\n.addRutto .addVideoAnteprimaVideo .buttonAddTo-cont .buttonAddTo:hover {\n  -webkit-transform: scale(1.05);\n          transform: scale(1.05);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(215);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("794a6f71", content, true, {});

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainLayout"
  }, [_c('section', {
    staticClass: "addRutto"
  }, [_c('div', {
    staticClass: "inputBase"
  }, [_c('p', [_vm._v("Inserisci qui l'url youtube del video che vuoi condividere con la comunita")]), _vm._v(" "), _c('div', {
    staticClass: "inserisciUrl-cont"
  }, [_c('i', {
    staticClass: "gdr-icon gdr-icon-youtube-play"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUrl),
      expression: "newUrl"
    }],
    staticClass: "inserisciUrl",
    attrs: {
      "type": "url",
      "pattern": "^(https://www.youtube.com/)"
    },
    domProps: {
      "value": (_vm.newUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUrl = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.youtubeVideoID) ? _c('div', {
    staticClass: "addVideoAnteprimaVideo",
    staticStyle: {
      "max-width": "450px"
    }
  }, [_c('p', [_vm._v("vuoi aggiungere questo video?")]), _vm._v(" "), _c('videoplayer', {
    attrs: {
      "videoID": _vm.youtubeVideoID,
      "previewType": "video",
      "vote": false,
      "shadow": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttonAddTo-cont"
  }, [_c('button', {
    staticClass: "buttonAddTo",
    on: {
      "click": _vm.addToCommunity
    }
  }, [_vm._v("Aggiungi alla lista")])])], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(221)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(243),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/5.f7e646a76b3fe34000c4.js